/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { equalDependencies } from './dependenciesEqual.generated.js';
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { modDependencies } from './dependenciesMod.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { xgcdDependencies } from './dependenciesXgcd.generated.js';
import { createInvmod } from '../../factoriesAny.js';
export var invmodDependencies = {
  BigNumberDependencies,
  addDependencies,
  equalDependencies,
  isIntegerDependencies,
  modDependencies,
  smallerDependencies,
  typedDependencies,
  xgcdDependencies,
  createInvmod
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesInvmod.generated.js
// module id = SzEn
// module chunks = 3